

const PricableType = Object.freeze({
    ProductSize: 'ps',
    ProductCustomization: 'pc'
});

const MenuItem = Object.freeze({
    MENU_ITEM: 'menu_item',
    SAMPLING_ITEM: 'sampling_item'
});

export {
    PricableType,
    MenuItem
};

// adds